import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getAuthToken } from 'utils/authToken';

function useOrganizationValidation() {
  const { organizationName } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    // Skip validation for deeplink routes - let them handle their own flow
    if (window.location.pathname.includes('integrations/deeplink')) {
      return;
    }

    const token = getAuthToken();
    const isPartnerSession =
      sessionStorage.getItem('is_partner_session') === 'true';

    if (isPartnerSession && token) {
      const orgName = localStorage.getItem('org_name');
      if (orgName && orgName !== organizationName) {
        navigate(`/${orgName}/device-info`);
      }
      return;
    }

    const orgName = localStorage.getItem('org_name');

    if (orgName) {
        // console.log('users org name is ->', orgName);
        if (orgName !== organizationName) {
          navigate(`/${orgName}/device-info`);
        }
      
    } else {
      navigate(`/${organizationName}/login`);
    }
  }, [organizationName, navigate]);
}

export default useOrganizationValidation;
